import React, { useContext, useEffect, useState } from 'react';
import { apiDelete, apiGet } from '../../../utils/apiFetch';
import apiPath from '../../../utils/apiPath';
import { AiFillDelete, AiFillEye } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { BsArrowUpShort } from 'react-icons/bs';
import { isArray, isEmpty, startCase } from 'lodash';
import Pagination from 'pages/Pagination';
import PropertListingView from './PropertListingView';
import helper from 'utils/helpers';
import AuthContext from 'context/AuthContext';
import useToastContext from 'hooks/useToastContext';
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker';
import dayjs from 'dayjs';

const PropertListing = ({ manager }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { config } = useContext(AuthContext);
  const [viewShowModal, setViewShowModal] = useState(false);
  const [item, setItem] = useState('');
  const [data, setData] = useState({
    totalDocs: 0,
    pageCount: 0,
    docs: [],
  });

  const [filter, setFilter] = useState({
    pagination: {
      page: 1,
      pageRangeDisplayed: 10,
    },
    query: {
      startDate: '',
      endDate: '',
      search: '',
      reset: false,
    },
    sort: {
      sortKey: 'createdAt',
      sortType: 'desc',
    },
  });

  const handleUserView = (item) => {
    setItem(item);
    setViewShowModal(true);
  };

  const getRequirementListing = async (data) => {
    try {
      const path = apiPath.queryPropertyList;
      const result = await apiGet(path, filter);
      const response = result?.data?.results;
      if (result?.data?.success) {
        setData({
          docs: response?.docs || [],
          totalDocs: response?.totalDocs || 0,
          pageCount: response?.totalPages || 0,
        });
      } else {
        notification.error(response?.message || 'Something went wrong.');
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message);
    }
  };

  const handleChange = (type, e) => {
    setFilter((prev) => {
      let obj = { ...prev };
      switch (type) {
        case 'filter':
          obj = {
            ...prev,
            query: {
              ...prev.query,
              search: e?.search,
              startDate: e?.startDate
                ? dayjs(e?.startDate).format('YYYY-MM-DD')
                : null,
              endDate: e?.endDate
                ? dayjs(e?.endDate).format('YYYY-MM-DD')
                : null,
            },
            pagination: {
              ...prev.pagination,
              page: 1,
            },
          };
          break;

        case 'pagination':
          obj = {
            ...prev,
            pagination: {
              ...prev.pagination,
              page: e,
            },
          };
          break;

        case 'sort':
          obj = {
            ...prev,
            sort: {
              sortKey: e?.sortKey,
              sortType: e?.sortType,
            },
          };
          break;
        default:
          break;
      }

      return obj;
    });
  };

  const handleResetDateFilter = (isReset) => {
    setFilter((prev) => {
      return {
        ...prev,
        query: {
          ...prev.query,
          startDate: '',
          endDate: '',
          reset: isReset,
        },
      };
    });
  };

  const deleteQuery = async (item) => {
    const path = apiPath.deletePropertyListingQuery;

    const response = await apiDelete(path + '/' + item._id);
    if (response?.data?.success) {
      notification.success(response.data.message);
      getRequirementListing();
    } else {
      notification.error(response.data.message);
    }
    try {
    } catch (error) {
      notification.error(error?.message || 'Something went wrong.');
    }
  };

  useEffect(() => {
    getRequirementListing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return (
    <>
      <div className="bg-white border border-[#E9EDF9] ">
        <div className="p-3">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <ODateRangePicker
                handleDateChange={(startDate, endDate) =>
                  handleChange('filter', { startDate, endDate })
                }
                isReset={filter.query.reset}
                setIsReset={handleResetDateFilter}
              />
              <button
                type="button"
                onClick={handleResetDateFilter}
                className="bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
              >
                {t('O_RESET')}
              </button>
            </div>
            <div className="relative ">
              <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                <svg
                  aria-hidden="true"
                  className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {!filter?.query?.search && (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  )}
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                name="search"
                title=""
                className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[300px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={t('O_SEARCH_BY_PROPERTY_QUERY_LISTING')}
                value={filter?.query?.search}
                required
                onChange={(e) =>
                  handleChange('filter', { search: e.target.value })
                }
              />
            </div>
          </div>
          <div className="overflow-x-auto relative 
 border">
            <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
              <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    #
                  </th>

                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('O_FULL_NAME')} </span>
                    </div>
                  </th>
                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('O_EMAIL_ADDRESS')} </span>
                    </div>
                  </th>
                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('O_USER_TYPE')} </span>
                    </div>
                  </th>
                  {/* <th
                    scope='col'
                    className='py-3 px-6 cursor-pointer'
                    onClick={() => {
                      if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                        setSort({
                          sortKey: 'name',
                          sortType: 'desc'
                        })
                      } else {
                        setSort({
                          sortKey: 'name',
                          sortType: 'asc'
                        })
                      }
                    }}
                  >
                    <div className='flex'>
                      <span>{t('O_MOBILE')} </span>
                      <span>
                        {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                          <BsArrowUpShort className='w-4 h-4' />
                        )}
                        {sort.sortKey === 'name' &&
                          sort.sortType === 'desc' && (
                            <BsArrowUpShort className='w-4 h-4 rotate-180' />
                          )}
                      </span>
                    </div>
                  </th> */}
                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('PROPERTY_TYPE')} </span>
                    </div>
                  </th>

                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('O_LOCATION')} </span>
                    </div>
                  </th>

                  <th scope="col" className="py-3 px-6 ">
                    <div className="flex">
                      <span>{t('O_PROPERTY_AGE')} </span>
                    </div>
                  </th>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t('O_PRICE')}
                  </th>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t('O_TOTAL_AREA')}
                  </th>

                  <th
                    scope="col"
                    className="py-3 px-6 cursor-pointer"
                    onClick={() => {
                      if (
                        filter.sort.sortKey === 'createdAt' &&
                        filter.sort.sortType === 'asc'
                      ) {
                        handleChange('sort', {
                          sortKey: 'createdAt',
                          sortType: 'desc',
                        });
                      } else {
                        handleChange('sort', {
                          sortKey: 'createdAt',
                          sortType: 'asc',
                        });
                      }
                    }}
                  >
                    <div className="flex">
                      <span>{t('O_CREATED_AT')} </span>
                      <span>
                        {filter.sort.sortKey === 'createdAt' &&
                          filter.sort.sortType === 'asc' && (
                            <BsArrowUpShort className="w-4 h-4" />
                          )}
                        {filter.sort.sortKey === 'createdAt' &&
                          filter.sort.sortType === 'desc' && (
                            <BsArrowUpShort className="w-4 h-4 rotate-180" />
                          )}
                      </span>
                    </div>
                  </th>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t('O_ACTION')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.docs.length > 0 &&
                  data.docs?.map((item, i) => (
                    <tr
                      key={i}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                    >
                      <th
                        scope="row"
                        className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                      >
                        {i + 1 + 10 * (filter.pagination?.page - 1)}
                      </th>
                      <td className="py-2 px-2 border-r">
                        {startCase(
                          item?.name ||
                            `${item?.userData?.firstName || ''} ${
                              item?.userData?.lastName || ''
                            }`
                        )}
                      </td>
                      <td className="py-2 px-2 border-r">
                        {item?.email || item?.userData?.email}
                      </td>
                      <td className="py-2 px-2 border-r">
                        {startCase(item?.userType)}
                      </td>
                      {/* <td className='py-2 px-2 border-r'>{item?.mobile}</td> */}
                      <td className="py-2 px-2 border-r">
                        {/* {startCase(item?.propertyType?.name)} */}
                        {item?.propertyType.length > 0
                          ? item?.propertyType
                              .map((type) => type?.name)
                              .join(', ')
                          : 'N/A'}
                      </td>
                      <td className="py-2 px-2 border-r">
                        {startCase(item?.cityData?.name) || 'N/A'}
                      </td>

                      <td className="py-2 px-2 border-r">
                        {isArray(item?.propertyAge)
                          ? item.propertyAge?.join(', ')
                          : item.propertyAge || 'N/A'}
                      </td>
                      <td className="py-2 px-2 border-r">
                        {item?.price
                          ? helper.priceFormat(item?.price) +
                            ' ' +
                            config.currency
                          : 'N/A'}
                      </td>
                      <td className="py-2 px-2 border-r">
                        {item?.area
                          ? item?.area + ' ' + config?.areaUnit
                          : 'N/A'}
                      </td>

                      <td className="py-2 px-2 border-r">
                        {helper.dateFormat(item?.createdAt) || 'N/A'}
                      </td>
                      <td className="py-4 px-6 border-l">
                        <div className="">
                          <ul className="flex justify-center">
                            <li
                              onClick={() => handleUserView(item)}
                              className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                            >
                              <button title={t('O_VIEW_USER')}>
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{' '}
                              </button>
                            </li>
                            {(manager?.delete || config?.role === 'admin') && (
                              <li
                                onClick={() =>
                                  helper.alertFunction(
                                    `Are you sure want to delete ${
                                      item?.reason?.name
                                        ? 'query: ' + item?.reason?.name
                                        : 'this query'
                                    }?`,
                                    item,
                                    deleteQuery
                                  )
                                }
                                className="px-1 py-2 hover:bg-white hover:text-LightBlue"
                              >
                                <button title={t('O_DELETE_USER')}>
                                  {' '}
                                  <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />{' '}
                                </button>
                              </li>
                            )}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  ))}
                {data.docs.length <= 0 && (
                  <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                    <td className="py-4 px-6" colSpan={12}>
                      {t('O_NO_RECORD_FOUND')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {data.totalDocs !== 0 && (
          <Pagination
            handlePageClick={(e) => handleChange('pagination', e?.selected + 1)}
            options={{
              ...filter.pagination,
              pageCount: data.pageCount,
              totalItems: data.totalDocs,
            }}
            page={filter.pagination.page}
          />
        )}
      </div>
      {viewShowModal && (
        <PropertListingView setViewShowModal={setViewShowModal} item={item} />
      )}
    </>
  );
};

export default PropertListing;
